import { HELP_DRAWER } from './constants';
import type { TPTTranslations } from './types';

export const en: TPTTranslations = {
  [HELP_DRAWER]: {
    HELP_TITLE: 'Help',

    HELP_DRAWER_TITLE: 'Help',
    HELP_DRAWER_RECOMMENDED: 'recommended articles',
    HELP_DRAWER_ARTICLE_1: 'How do I upload users to Crehana?',
    HELP_DRAWER_ARTICLE_2: 'How to manage users?',
    HELP_DRAWER_ARTICLE_3: 'Create attributes',
    HELP_DRAWER_ARTICLE_4: 'How do I see the performance of my attributes?',
    HELP_DRAWER_HELP_CENTER: 'See more in the Help Center',
    HELP_DRAWER_TECH_ASSISTANCE: 'technical assistance',
    HELP_DRAWER_DOUBTS_TITLE: 'Doubts and queries',
    HELP_DRAWER_DOUBTS_SUBTITLE: 'Get support from our team',
    HELP_DRAWER_FEEDBACK_TITLE: 'Leave us your feedback',
    HELP_DRAWER_FEEDBACK_SUBTITLE: 'Your opinion is important',
    HELP_DRAWER_EMAIL_TITLE: 'Still with doubts? Write to us at:',
  },
};
